import { render, staticRenderFns } from "./NewPostDoc.vue?vue&type=template&id=54c428d3&"
import script from "./NewPostDoc.vue?vue&type=script&lang=js&"
export * from "./NewPostDoc.vue?vue&type=script&lang=js&"
import style0 from "./NewPostDoc.vue?vue&type=style&index=0&id=54c428d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports